var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        staticClass: "user-form login package",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.saveProfile($event)
          }
        }
      },
      [
        _c("h3", [_vm._v("Past payments")]),
        _vm._v(" "),
        _vm._l(_vm.item.allPayments, function(payment) {
          return payment.id != _vm.item.activePayment.id
            ? _c("div", [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "margin-bottom": "10px" } },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "label",
                          {
                            staticStyle: {
                              position: "relative",
                              "z-index": "1",
                              "text-align": "center"
                            }
                          },
                          [_vm._v("Start date")]
                        ),
                        _vm._v(" "),
                        _c("datepicker", {
                          staticStyle: {
                            "margin-top": "-20px",
                            padding: "20px 0 0",
                            "text-align": "center"
                          },
                          model: {
                            value: payment.rangeStartDate,
                            callback: function($$v) {
                              _vm.$set(payment, "rangeStartDate", $$v)
                            },
                            expression: "payment.rangeStartDate"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { "margin-left": "10px" } },
                      [
                        _c(
                          "label",
                          {
                            staticStyle: {
                              position: "relative",
                              "z-index": "1",
                              "text-align": "center"
                            }
                          },
                          [_vm._v("End date")]
                        ),
                        _vm._v(" "),
                        _c("datepicker", {
                          staticStyle: {
                            "margin-top": "-20px",
                            padding: "20px 0 0",
                            "text-align": "center"
                          },
                          model: {
                            value: payment.rangeEndDate,
                            callback: function($$v) {
                              _vm.$set(payment, "rangeEndDate", $$v)
                            },
                            expression: "payment.rangeEndDate"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-left": "10px" } }, [
                      _c(
                        "button",
                        {
                          staticClass: "main",
                          staticStyle: {
                            width: "30px",
                            height: "20px",
                            "font-size": "1.3em",
                            "line-height": "20px",
                            "margin-top": "-1px"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.updatePayment(payment)
                            }
                          }
                        },
                        [_vm._v("✓")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "main",
                          staticStyle: {
                            width: "30px",
                            height: "20px",
                            "font-size": "1.3em",
                            "line-height": "20px",
                            "margin-top": "5px",
                            background: "#e03020"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.deletePayment(payment)
                            }
                          }
                        },
                        [_vm._v("×")]
                      )
                    ])
                  ]
                )
              ])
            : _vm._e()
        }),
        _vm._v(" "),
        !_vm.item.activePayment
          ? _c("div", [
              _c("div", { staticClass: "none" }, [
                _vm._v("(no active package)")
              ])
            ])
          : _c("div", [
              _c("h3", [_vm._v("Current payment")]),
              _vm._v(" "),
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.item.activePayment.package.name))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "10px" } },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "label",
                        {
                          staticStyle: {
                            position: "relative",
                            "z-index": "1",
                            "text-align": "center"
                          }
                        },
                        [_vm._v("Start date")]
                      ),
                      _vm._v(" "),
                      _c("datepicker", {
                        staticStyle: {
                          "margin-top": "-20px",
                          padding: "20px 0 0",
                          "text-align": "center"
                        },
                        model: {
                          value: _vm.item.activePayment.rangeStartDate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.item.activePayment,
                              "rangeStartDate",
                              $$v
                            )
                          },
                          expression: "item.activePayment.rangeStartDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "margin-left": "10px" } },
                    [
                      _c(
                        "label",
                        {
                          staticStyle: {
                            position: "relative",
                            "z-index": "1",
                            "text-align": "center"
                          }
                        },
                        [_vm._v("End date")]
                      ),
                      _vm._v(" "),
                      _c("datepicker", {
                        staticStyle: {
                          "margin-top": "-20px",
                          padding: "20px 0 0",
                          "text-align": "center"
                        },
                        model: {
                          value: _vm.item.activePayment.rangeEndDate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.item.activePayment,
                              "rangeEndDate",
                              $$v
                            )
                          },
                          expression: "item.activePayment.rangeEndDate"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("button", { staticClass: "main" }, [
                _vm._v("Activate & Send email")
              ])
            ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }